import React from 'react';
import { Plus, Trash2, Image as ImageIcon, Sparkles } from 'lucide-react';
import { PageSection } from '../../../../types';

interface GalleryEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const GalleryEditor: React.FC<GalleryEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};
  const images: any[] = content.images || content.items || [
    { url: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=800&auto=format&fit=crop', caption: 'Lüks Motoryat' },
    { url: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=800&auto=format&fit=crop', caption: 'Masmavi Koylarda Seyir' },
    { url: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?q=80&w=800&auto=format&fit=crop', caption: 'Güneşlenme Güvertesi' },
  ];

  const handleUpdateImage = (index: number, updates: any) => {
    const next = [...images];
    next[index] = { ...next[index], ...updates };
    onUpdateContent({ images: next, items: next });
  };

  const handleAddImage = () => {
    const next = [
      ...images,
      {
        url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&auto=format&fit=crop',
        caption: 'Yeni Galeri Görseli',
      },
    ];
    onUpdateContent({ images: next, items: next });
  };

  const handleDeleteImage = (index: number) => {
    const next = images.filter((_, i) => i !== index);
    onUpdateContent({ images: next, items: next });
  };

  return (
    <div className="space-y-6">
      {/* Headings */}
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">Galeri Başlıkları</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Üst Rozet</label>
          <input
            type="text"
            value={content.badge ?? 'FOTOĞRAF GALERİSİ'}
            onChange={(e) => onUpdateContent({ badge: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-semibold text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Ana Başlık</label>
          <input
            type="text"
            value={content.title ?? 'Unutulmaz Anlar ve Detaylar'}
            onChange={(e) => onUpdateContent({ title: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-bold text-slate-100 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>
      </div>

      {/* Images List */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ImageIcon className="w-4 h-4 text-blue-400" />
            <h4 className="text-xs font-extrabold text-slate-200">Görseller ({images.length})</h4>
          </div>
          <button
            type="button"
            onClick={handleAddImage}
            className="px-2.5 py-1.5 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-[11px] font-bold flex items-center gap-1.5 shadow-sm transition"
          >
            <Plus className="w-3.5 h-3.5" />
            <span>Görsel Ekle</span>
          </button>
        </div>

        <div className="space-y-2.5">
          {images.map((img, idx) => (
            <div key={idx} className="p-3 rounded-2xl bg-slate-800/40 border border-slate-700/60 flex items-center gap-3">
              <img
                src={typeof img === 'string' ? img : img.url}
                alt=""
                className="w-12 h-12 rounded-xl object-cover bg-slate-900 border border-slate-700 shrink-0"
              />
              <div className="flex-1 space-y-1 min-w-0">
                <input
                  type="url"
                  value={typeof img === 'string' ? img : (img.url || '')}
                  onChange={(e) => handleUpdateImage(idx, { url: e.target.value })}
                  placeholder="Görsel URL..."
                  className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 px-2 py-1 rounded-lg outline-none focus:border-blue-500"
                />
                <input
                  type="text"
                  value={typeof img === 'string' ? '' : img.caption || ''}
                  onChange={(e) => handleUpdateImage(idx, { caption: e.target.value })}
                  placeholder="Başlık / Açıklama (opsiyonel)"
                  className="w-full bg-slate-900 border border-slate-700 text-[11px] text-slate-400 px-2 py-0.5 rounded-lg outline-none focus:border-blue-500"
                />
              </div>
              <button
                type="button"
                onClick={() => handleDeleteImage(idx)}
                className="p-2 text-slate-500 hover:text-rose-400 transition"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
